import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Box, Button, TextField, SplitButtonDropdown} from 'views/components';
import {Avatar, MarkdownEditorWithAutosave} from 'views/module';
import {translate, Translate} from 'views/module';

const NewMessageBox = (props) => {
  const [newMessage, setNewMessage] = React.useState('');
  const [textFieldClicked, setTextFieldClicked] = React.useState(false);
  const [createNewMessageLoading, setCreateNewMessageLoading] = React.useState(false);
  const [openSaveAs, setOpenSaveAs] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const {
    user,
    caregiverRn,
    caregiverBackend,
  } = props;

  const saveString = `CAREGIVER-CORRESPONDANCE-${caregiverRn}`;
  const saveAsOptions = [
    {
      key: 'COMMENTS',
      text: translate('caregiver.CaregiverDetail.Correspondance.NewMessage.Comments'),
    },
    {
      key: 'ANNOUNCEMENTS',
      text: translate('caregiver.CaregiverDetail.Correspondance.NewMessage.Announcements'),
    },
  ];
  const saveAsAnchorRef = React.useRef(null);

  const onSave = (event) => {
    setOpenSaveAs(false);
    if (!saveAsOptions[selectedIndex]) {
      return;
    }
    if (!newMessage || newMessage.trim() === '') {
      return;
    }
    event.preventDefault();

    const messageType = saveAsOptions[selectedIndex].key;

    setCreateNewMessageLoading(true);
    caregiverBackend.messages.create(messageType, newMessage, () => {
      setNewMessage('');
      // remove value in local storage to clear newMessage comepletely
      // MarkdownEditor gets the value in localStorage before we can even set the new empty value
      localStorage.removeItem(saveString);
      setCreateNewMessageLoading(false);
      setTextFieldClicked(false);
    }, () => setCreateNewMessageLoading(false));
  };

  const onCancel = () => {
    setOpenSaveAs(false);
    setTextFieldClicked(false);
  };

  const onSaveAsToggle = () => {
    setOpenSaveAs((prevOpen) => !prevOpen);
  };

  const onSaveAsClickAway = (event) => {
    if (saveAsAnchorRef.current && saveAsAnchorRef.current.contains(event.target)) {
      return;
    }

    setOpenSaveAs(false);
  };

  const onSaveAsMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpenSaveAs(false);
  };

  return (
    <Stack direction='row' spacing={2} >
      <Box>
        <Avatar
          resourceRn={user.userRn}
          detail={{
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
          }}
        />
      </Box>
      <Box sx={{width: '100%'}}>
        {
          !textFieldClicked ?
            <TextField
              variant='outlined'
              placeholder={translate('caregiver.CaregiverDetail.Correspondance.NewMessage.AddACommentOrAnnouncements')}
              onClick={() => setTextFieldClicked(true)}
              onChange={() => undefined}
              fullWidth
              sx={{
                'height': '42px',
                '& .MuiInputBase-root': {
                  height: '100%', // Ensure the input itself takes the full height
                },
              }}
            /> :
            <Stack spacing={2}>
              <Box>
                <MarkdownEditorWithAutosave
                  value={newMessage}
                  onChange={setNewMessage}
                  saveString={saveString}
                  autoFocus />
              </Box>
              <Box xs={12}>
                <Stack direction={'row'} spacing={1} justifyContent='flex-end'>
                  <Button variant='outlined' sx={{height: '42px'}} onClick={onCancel}>
                    <Translate expression='caregiver.CaregiverDetail.Correspondance.NewMessage.Cancel'/>
                  </Button>
                  <SplitButtonDropdown
                    options={saveAsOptions}
                    open={openSaveAs}
                    selectedIndex={selectedIndex}
                    label={saveAsOptions[selectedIndex].text}
                    onClickPrimaryButton={onSave}
                    onClickArrowButton={onSaveAsToggle}
                    onClickAway={onSaveAsClickAway}
                    onMenuItemClick={onSaveAsMenuItemClick}
                    anchorRef={saveAsAnchorRef}
                    loading={createNewMessageLoading}
                  />
                </Stack>
              </Box>
            </Stack>
        }
      </Box>
    </Stack>
  );
};
NewMessageBox.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, dispatch)(React.memo(NewMessageBox));

